export default function flashMessage(type: string, title: string , message: string) {
  const flashMessageElement = document.getElementById(
    'flashMessage'
  ) as HTMLDivElement;

  flashMessageElement.appendChild(
    document.getElementById('msg-text') as HTMLDivElement
  ).innerHTML =  `
  <p class="msg-text-top">${title}</p>
  <p class="msg-text-bottom">${message}</p>
  `
  flashMessageElement.className = `msg ${type} animated bounceInDown`;
  flashMessageElement.style.display = 'block';
  setTimeout(() => {
    flashMessageElement.classList.add('bounceOutUp');
    flashMessageElement.style.display = 'none';
  }, 5000);
}
